import { Paper, Stack, Text } from "~/ui";

type Props = {
  facts: readonly { label: string; value: string | null | undefined }[];
};

/** Order facts are corrected on the order; issuance fields remain below this summary. */
export const OrderDocumentSavedFacts = ({ facts }: Props) => {
  const populatedFacts = facts.filter(fact => fact.value?.trim());
  return (
    <Paper withBorder p="sm">
      <Stack spacing="xs">
        <Text size="sm" weight={600}>
          Saved order details
        </Text>
        {populatedFacts.map(fact => (
          <Text key={fact.label} size="sm">
            <Text component="span" weight={600}>
              {fact.label}:{" "}
            </Text>
            {fact.value}
          </Text>
        ))}
        <Text size="xs" color="dimmed">
          To change shipment details, update the order before generating this document.
        </Text>
      </Stack>
    </Paper>
  );
};
